<div class="product-item-loading">
  <skeleton skeletonModifier="skeleton_with-corners" width="90px" height="90px"></skeleton>
  <div class="product-item-loading__info">
    <skeleton height="15px" width="250px"></skeleton>
    <skeleton height="10px" width="200px"></skeleton>
    <skeleton height="10px" width="100%"></skeleton>
    <skeleton height="10px" width="100%"></skeleton>
  </div>
</div>
